import { Text } from "@/ui/core";
import { Box } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";

interface BookingTitleHeaderProps extends ViewWithTestID {
  title: string;
}

const BookingTitleHeader = ({ testID, title }: BookingTitleHeaderProps) => {
  return (
    <Box paddingBottom={24}>
      <Text color={ColorToken.NeutralPrimary} testID={testID}>
        {title}
      </Text>
    </Box>
  );
};

export default BookingTitleHeader;
